import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { completeOidcLogin } from '../../slices/thunks';
import '../../App.css';
import { MoonLoader } from 'react-spinners';
import { formatLoginError } from './loginErrorUtils';

const SigninOidc = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const errorMsg = useSelector(state => state.Login.error);

  // Guard: callback OIDC hanya boleh diproses SATU kali.
  // Tanpa ini, effect yang terpanggil dua kali (React 18 dev double-mount
  // atau re-render dengan dependency berubah) membuat panggilan kedua ke
  // signinRedirectCallback() throw "No matching state found in storage",
  // yang catch-nya navigate('/login') dan MENIMPA navigasi '/dashboard'
  // yang sukses dari panggilan pertama.
  const called = useRef(false);
  useEffect(() => {
    if (called.current) return;
    called.current = true;
    dispatch(completeOidcLogin(navigate));
  }, [dispatch, navigate]);

  return (
    <div className='loading-container'>
      {errorMsg ? (
        <div className='text-danger mb-3 px-3 text-center'>
          {String(errorMsg)}
        </div>
      ) : null}
      <MoonLoader
        color='#3498db' // Warna spinner
        loading={true} // Selalu true karena ini adalah halaman loading
        size={50} // Ukuran spinner dalam pixel
      />
      <p>Processing login...</p>
      {/* state router dipertahankan untuk keperluan debugging redirect */}
      {location.state?.oidcError ? (
        <div className='text-danger px-3'>
          {formatLoginError(location.state.oidcError)}
        </div>
      ) : null}
    </div>
  );
};

export default SigninOidc;
